import compose from 'recompose/compose';
import withState from 'recompose/withState';
import { connect } from 'react-redux';
import find from 'ramda/es/find';
import propEq from 'ramda/es/propEq';
import { withTranslation } from 'react-i18next';

import { subPrepayd } from 'app/actions/apps/subs/prepayd';


export default compose(
  withState('months', 'setMonths', null),
  withState('comment', 'setComment', ''),

  withTranslation('tariff'),

  connect(
    state => ({
      submitting: state.apps.opts.paying,
    }),
    (dispatch, { months, setMonths, setComment, periods, subId, handleToggle, t }) => ({
      handleCheck: (e) => {
        const { name, checked } = e.currentTarget;
        if (checked) {
          const number = parseInt(name, 10);
          setMonths(number);
          const hasNumber = propEq('months_number', number);
          const period = find(hasNumber, periods);
          setComment(
            (period.title && period.cost)
              ? t('buy_subscribe_confirm_with_cost', { title: period.title, cost: '{inject_price}' })
              : t('buy_subscribe_confirm')

            // (period.title && period.cost)
            //   ? <span>
            //     <span>{`Купить подписку "${period.title}" за `}</span>
            //     <PriceDiscounted
            //       studentId={studentId}
            //       tariffId={tariffId}
            //       tariffBundleId={tariffBundleId}
            //       priceType={priceTypes.price_base_on_months}
            //       monthsNumber={period.months_number}
            //     />
            //     <span>{'?'}</span>
            //   </span>
            // : 'Купить подписку?'
          );
        }
      },
      handleSubmit: async (e) => {
        e.preventDefault();
        const res = await dispatch(subPrepayd(subId, months));
        if (res) {
          handleToggle();
        }
      },
    })
  )
);
